"use strict";
exports.__esModule = true;
var react_native_1 = require("react-native");
exports.isReactNativeMobile = function () {
    return react_native_1.Platform.OS === "ios" || react_native_1.Platform.OS === "android";
};
//# sourceMappingURL=Utilities.js.map